import { postSmsOptOut } from '@nemuru-eng/js-api-client';

import { ActionDialog } from '@/components/shared/components/ActionDialog';
import { Text } from '@/components/shared/components/Text';
import { useTranslation } from '@/components/shared/hooks/useTranslation';
import { usePageContext } from '@/contexts/PageContext/PageContext';
import { useRequest } from '@/hooks/requests/useRequest';

interface OptOutNotificationsDialogProps {
  opened: boolean;
  setOpened: (value: boolean) => void;
  handleClose: () => void;
}

export const OptOutNotificationsDialog = ({ opened, setOpened, handleClose }: OptOutNotificationsDialogProps) => {
  const { request, loading } = useRequest();
  const { getTextIdTranslation } = useTranslation();
  const {
    state: { applicationParticipant },
  } = usePageContext();

  const onSubmit = async () => {
    if (!applicationParticipant?.onboardingDetails?.id) return null;
    try {
      await request(postSmsOptOut, { onboardingDetailsId: applicationParticipant.onboardingDetails.id });
    } catch (error) {
      console.log(error);
    } finally {
      handleClose();
    }
  };

  if (!applicationParticipant?.onboardingDetails) return null;

  return (
    <ActionDialog
      opened={opened}
      setOpened={setOpened}
      handleClose={handleClose}
      Title={<Text tId={'OPT_OUT_NOTIFICATIONS'} />}
      Description={
        <Text
          tId={'OPT_OUT_NOTIFICATIONS_DESCRIPTION'}
          dynamicDataTexts={[
            `${applicationParticipant.onboardingDetails.invitation.fullName.firstName} ${
              applicationParticipant.onboardingDetails.invitation.fullName.lastName
            } (${getTextIdTranslation(applicationParticipant.role).toLowerCase()})`,
          ]}
        />
      }
      MainButton={<Text tId={'OPT_OUT_NOTIFICATIONS_BTN'} />}
      onSubmit={onSubmit}
      loading={loading}
    />
  );
};
